// Domain types for app extensions
// These replace the GraphQL enums that are no longer generated

export enum AppExtensionMountEnum {
  PRODUCT_OVERVIEW_CREATE = "PRODUCT_OVERVIEW_CREATE",
  PRODUCT_OVERVIEW_MORE_ACTIONS = "PRODUCT_OVERVIEW_MORE_ACTIONS",
  PRODUCT_DETAILS_MORE_ACTIONS = "PRODUCT_DETAILS_MORE_ACTIONS",
  PRODUCT_DETAILS_WIDGETS = "PRODUCT_DETAILS_WIDGETS",
  NAVIGATION_CATALOG = "NAVIGATION_CATALOG",
  NAVIGATION_ORDERS = "NAVIGATION_ORDERS",
  NAVIGATION_CUSTOMERS = "NAVIGATION_CUSTOMERS",
  NAVIGATION_DISCOUNTS = "NAVIGATION_DISCOUNTS",
  NAVIGATION_TRANSLATIONS = "NAVIGATION_TRANSLATIONS",
  NAVIGATION_PAGES = "NAVIGATION_PAGES",
  ORDER_DETAILS_MORE_ACTIONS = "ORDER_DETAILS_MORE_ACTIONS",
  ORDER_OVERVIEW_CREATE = "ORDER_OVERVIEW_CREATE",
  ORDER_DETAILS_WIDGETS = "ORDER_DETAILS_WIDGETS",
  DRAFT_ORDER_DETAILS_WIDGETS = "DRAFT_ORDER_DETAILS_WIDGETS",
  DRAFT_ORDER_DETAILS_MORE_ACTIONS = "DRAFT_ORDER_DETAILS_MORE_ACTIONS",
  ORDER_OVERVIEW_MORE_ACTIONS = "ORDER_OVERVIEW_MORE_ACTIONS",
  DRAFT_ORDER_OVERVIEW_CREATE = "DRAFT_ORDER_OVERVIEW_CREATE",
  DRAFT_ORDER_OVERVIEW_MORE_ACTIONS = "DRAFT_ORDER_OVERVIEW_MORE_ACTIONS",
  CUSTOMER_OVERVIEW_CREATE = "CUSTOMER_OVERVIEW_CREATE",
  CUSTOMER_OVERVIEW_MORE_ACTIONS = "CUSTOMER_OVERVIEW_MORE_ACTIONS",
  CUSTOMER_DETAILS_MORE_ACTIONS = "CUSTOMER_DETAILS_MORE_ACTIONS",
  CUSTOMER_DETAILS_WIDGETS = "CUSTOMER_DETAILS_WIDGETS",
  CATEGORY_DETAILS_MORE_ACTIONS = "CATEGORY_DETAILS_MORE_ACTIONS",
  CATEGORY_OVERVIEW_CREATE = "CATEGORY_OVERVIEW_CREATE",
  CATEGORY_OVERVIEW_MORE_ACTIONS = "CATEGORY_OVERVIEW_MORE_ACTIONS",
  COLLECTION_DETAILS_MORE_ACTIONS = "COLLECTION_DETAILS_MORE_ACTIONS",
  COLLECTION_DETAILS_WIDGETS = "COLLECTION_DETAILS_WIDGETS",
  COLLECTION_OVERVIEW_CREATE = "COLLECTION_OVERVIEW_CREATE",
  COLLECTION_OVERVIEW_MORE_ACTIONS = "COLLECTION_OVERVIEW_MORE_ACTIONS",
  GIFT_CARD_DETAILS_MORE_ACTIONS = "GIFT_CARD_DETAILS_MORE_ACTIONS",
  GIFT_CARD_DETAILS_WIDGETS = "GIFT_CARD_DETAILS_WIDGETS",
  GIFT_CARD_OVERVIEW_CREATE = "GIFT_CARD_OVERVIEW_CREATE",
  GIFT_CARD_OVERVIEW_MORE_ACTIONS = "GIFT_CARD_OVERVIEW_MORE_ACTIONS",
  VOUCHER_DETAILS_MORE_ACTIONS = "VOUCHER_DETAILS_MORE_ACTIONS",
  VOUCHER_DETAILS_WIDGETS = "VOUCHER_DETAILS_WIDGETS",
  VOUCHER_OVERVIEW_CREATE = "VOUCHER_OVERVIEW_CREATE",
  VOUCHER_OVERVIEW_MORE_ACTIONS = "VOUCHER_OVERVIEW_MORE_ACTIONS",
  DISCOUNT_DETAILS_MORE_ACTIONS = "DISCOUNT_DETAILS_MORE_ACTIONS",
  DISCOUNT_OVERVIEW_CREATE = "DISCOUNT_OVERVIEW_CREATE",
  DISCOUNT_OVERVIEW_MORE_ACTIONS = "DISCOUNT_OVERVIEW_MORE_ACTIONS",
  MENU_DETAILS_MORE_ACTIONS = "MENU_DETAILS_MORE_ACTIONS",
  MENU_OVERVIEW_CREATE = "MENU_OVERVIEW_CREATE",
  MENU_OVERVIEW_MORE_ACTIONS = "MENU_OVERVIEW_MORE_ACTIONS",
  PAGE_DETAILS_MORE_ACTIONS = "PAGE_DETAILS_MORE_ACTIONS",
  PAGE_OVERVIEW_CREATE = "PAGE_OVERVIEW_CREATE",
  PAGE_OVERVIEW_MORE_ACTIONS = "PAGE_OVERVIEW_MORE_ACTIONS",
  PAGE_TYPE_DETAILS_MORE_ACTIONS = "PAGE_TYPE_DETAILS_MORE_ACTIONS",
  PAGE_TYPE_OVERVIEW_CREATE = "PAGE_TYPE_OVERVIEW_CREATE",
  PAGE_TYPE_OVERVIEW_MORE_ACTIONS = "PAGE_TYPE_OVERVIEW_MORE_ACTIONS",
  TRANSLATIONS_MORE_ACTIONS = "TRANSLATIONS_MORE_ACTIONS",
}

export enum AppExtensionTargetEnum {
  POPUP = "POPUP",
  APP_PAGE = "APP_PAGE",
  NEW_TAB = "NEW_TAB",
  WIDGET = "WIDGET",
}
